import { connect } from "react-redux";
import LocationType from "./../LocationType";
import _ from "lodash";
import StatementLabel from "./StatementLabel";
import { updateStatementLabel } from "./../../../../../redux/actions/surveyActions";

const mapStateToProps = (state, ownProps) => {
	//TODO selectors/reducers
	const surveyProgress = state.survey.surveyManager.surveyProgress;
	const locationTypes = surveyProgress.locationTypes || [];
	const locationTypeDataIndex = _.findIndex(locationTypes, {
		locationTypeId: ownProps.locationType.locationTypeId,
	});
	const locationTypeData =
		locationTypeDataIndex !== -1 ? locationTypes[locationTypeDataIndex] : {};
	const locationType = new LocationType(locationTypeData);
	const statement = locationType.getStatement(ownProps.statement.statementId);
	const label =
		statement && ownProps.statement.label !== statement.label
			? statement.label
			: ownProps.statement.label;

	return {
		label: label,
	};
};
const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		updateStatementLabel: (label = "") => {
			dispatch(
				updateStatementLabel(ownProps.locationType, ownProps.statement, label)
			);
		},
	};
};
export default connect(
	mapStateToProps,
	mapDispatchToProps
)(StatementLabel);



// WEBPACK FOOTER //
// src/components/survey/create/SurveyStepActionsKpi/SurveyStepActionsKpiTabElements/StatementLabelContainer.js